// // src/app/shop/ShopClientWrapper.tsx
'use client';

import { useState, useEffect } from 'react';
import { ProductGrid } from './ProductGrid';
import { Pagination } from './Pagination';
import { useRouter, useSearchParams } from 'next/navigation';
import { fetchWooProducts, convertWooProduct } from '@/lib/woocommerceCatalog';

interface ShopClientWrapperProps {
    initialProducts: any[];
    initialTotal: number;
    initialTotalPages: number;
    currentPage: number;
    perPage: number;
    showStock: boolean;
}

export function ShopClientWrapper({
    initialProducts,
    initialTotal,
    initialTotalPages,
    currentPage,
    perPage,
    showStock,
}: ShopClientWrapperProps) {
    const [products, setProducts] = useState(initialProducts);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [currentLoadedPage, setCurrentLoadedPage] = useState(currentPage);
    const searchParams = useSearchParams();
    const router = useRouter();

    const [isLoadMore, setIsLoadMore] = useState(false);

    useEffect(() => {
        if (!isLoadMore) {
            setProducts(initialProducts);
            setCurrentLoadedPage(currentPage);
        }
        setIsLoadMore(false);
    }, [searchParams.get('page'), initialProducts, currentPage]);

    const loadMore = async () => {
        if (isLoadingMore) return;
        setIsLoadingMore(true);
        setIsLoadMore(true);

        try {
            const nextPage = currentLoadedPage + 1;
            const { products: newProducts } = await fetchWooProducts(nextPage, perPage);
            const convertedProducts = newProducts.map(convertWooProduct);

            setProducts((prevProducts) => [...prevProducts, ...convertedProducts]);
            setCurrentLoadedPage(nextPage);
            router.push(`/shop?page=${nextPage}`, { scroll: false });
        } catch (error) {
            console.error('Error loading more products:', error);
        } finally {
            setIsLoadingMore(false);
        }
    };

    const displayedCount = Math.min(currentLoadedPage * perPage, initialTotal);

    return (
        <>
            <h2 style={{ marginBottom: '15px' }}>
                Отображено {(currentPage - 1) * perPage + 1}–
                {displayedCount} из {initialTotal}
            </h2>

            <ProductGrid products={products} showStock={showStock} />

            <div className="shop_actions">
                {currentLoadedPage < initialTotalPages && (
                    <div className="load_more_container">
                        <button
                            onClick={loadMore}
                            disabled={isLoadingMore}
                            className="load_more_button text-black bg-[#ebebeb] hover:bg-[#ebebeb]"
                        >
                            {isLoadingMore ? 'Загрузка...' : 'Загрузить еще'}
                        </button>
                    </div>
                )}

                <div className="pagination_controls">
                    {initialTotalPages > 1 && (
                        <Pagination
                            currentPage={currentPage}
                            totalPages={initialTotalPages}
                        />
                    )}
                </div>
            </div>
        </>
    );
}